import * as React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { LoginController } from "@njoy/controller";
import { LoginView } from "./ui/LoginView";
import * as ROUTES from "../../../constants/routes";

export const LoginConnector: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const onFinish = () => {
    const state = location.state as { next?: string } | null;
    // Only redirect if next exists and is not /login
    if (state && state.next && state.next !== ROUTES.LOGIN) {
      navigate(state.next);
    } else {
      navigate(ROUTES.HOME);
    }
  };

  return (
    <LoginController>
      {({ submit }:{submit:any}) => ( // remove " :{submit:any} " before push
        <LoginView
          onFinish={onFinish}
          submit={async (values) => {
            const result = await submit(values);

            const name = `${result?.message?.split(" ")[0]} ${result?.message?.split(" ")[1]}`;
            const deactivationDate = `${result?.message?.split(" ")[2]} ${result?.message?.split(" ")[3]} ${result?.message?.split(" ")[4]} ${result?.message?.split(" ")[5]}`;

            // console.log("name ", name);
            // console.log("deactivate date ", deactivationDate)

            if(result?.errors && result?.errors.deactivation === "User account pending deletion.") {
              localStorage.setItem("email", values.email);
              localStorage.setItem("name", name || "");
              localStorage.setItem("deactivationDate", deactivationDate || "");
              window.location.replace(ROUTES.ACCOUNT_PENDING_DELETION);
            }

            return result?.errors ?? null;
          }}
        />
      )}
    </LoginController>
  );
};